import { Component, type ReactNode } from "react";
import { Button } from "@/components/ui/button";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-background flex items-center justify-center px-4">
          <div className="text-center space-y-6">
            <div className="w-2 h-2 rounded-full bg-destructive mx-auto" />
            <h1 className="font-display text-2xl italic text-foreground">
              Something went wrong
            </h1>
            <p className="text-sm text-muted-foreground max-w-sm">
              An unexpected error occurred. Please try again.
            </p>
            <Button
              variant="outline"
              className="rounded-none text-xs tracking-widest uppercase"
              onClick={() => {
                this.setState({ hasError: false });
                window.location.href = "/";
              }}
            >
              Go Home
            </Button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
